import { GetPageTitle } from "../../ErnotsConfig";
import { DictionaryLink, Language } from "../../rest/models";
import { getModelMap } from "../../rest/slice";
import { useAppSelector } from "../../store/hooks";
import { NothingToShow, PleaseWait, DictRequestStatusDisplay } from "../CommonComponents";
import { Button } from "../RequestRespectingInputs";
import { DictionaryExplanations } from "./explanation";
import { useEffect, useState } from "react";
import { RestObjectDDL } from "../../rest/components/RestObjectDDL";
import { groupBy } from "../../utils";
import { DictLinkLanguageListRow } from "./DictLinkLanguageListRow";

export function DictLinkList()
{
    const dictModels = getModelMap(useAppSelector, DictionaryLink);
    const langModels = getModelMap(useAppSelector,  Language);
    
    const hasData = dictModels != null && langModels != null;
    
    //Languages for which DictLinkLanguageListRow are displayed.
    const [dictLangs, setDictLangs] = useState({} as {[langId: string]: true});

    //Selected value for the language dropdown.
    const [newDictLang, setNewDictLang] = useState('');

    //Adds to the dict, and then sets the state to its copy.
    //(If I don't make a copy, the page doesn't rerender.)
    function addDictLang(langId: string)
    {
        if (langId)
        {
            dictLangs[langId] = true;
            setDictLangs({...dictLangs});
        }
    }
    
    useEffect(function()
    {
        //Add languages from existing objects to dictLangs, so their blocks aren't removed if the objects are deleted.
        Object
            .values(dictModels ?? {})
            .map(d => d.language ?? '')
            .filter(langId => !dictLangs[langId])
            .forEach(addDictLang);
    });
    
    let ret = <>
        <PleaseWait what='the dictionary table'/>
        <DictRequestStatusDisplay modelClass={DictionaryLink} />
        <DictRequestStatusDisplay modelClass={Language} />
    </>;
    
    if (hasData)
    {
        const dictModels2 = Object.values(dictModels);
        const langsModels2 = Object.values(langModels);

        langsModels2.sort((a, b) => a.name.localeCompare(b.name));
        
        //Group dicts by language and sort by text.        
        const dictsByLang = groupBy(dictModels2, d => d.language ?? '', a => a.text);

        //undefined represents the dictionaries useful for any language, such as Wiktionary.
        const langsForRows = [undefined, ...langsModels2.filter(l => dictLangs[l.key])];
        const langRows = langsForRows.map(function(l)
        {
            const key = l?.key ?? '';
            return <DictLinkLanguageListRow key={key} lang={l} dicts={dictsByLang[key] ?? []}/>
        });

        ret = langRows.length ? <>{langRows}</> : <NothingToShow what='dictionaries'/>;
    }

    return (
        <div className='ernots_ModelEditor ernots_DictLinkEditor'>
            <title>{GetPageTitle('Dictionary Links')}</title>
            {DictionaryExplanations.header}
            
            <div className='ernots_HorizontalLine'/>
            Create dictionaries for language:
            <br/>
            <RestObjectDDL
                name='createAbbrsFor'
                modelClass={Language}
                property='name'
                hasEmptyOption={true}
                selection={newDictLang}
                handleChange={val => setNewDictLang(val)} />
            <Button onClick={e => addDictLang(newDictLang)}>Create</Button>

            {ret}
    </div>);
}